export default __webpack_public_path__ + "static/media/dvs-flat.4eff1996.png";